import React from "react";
import Chart from "react-apexcharts";
import { CHART_COLORS } from "./analyticsUtils";

const SalesTrendChart = ({ trend }) => {
    const labels = trend?.labels || [];
    const sales = trend?.sales || [];
    const purchases = trend?.purchases || [];
    const hasData = sales.some((v) => v > 0) || purchases.some((v) => v > 0);

    const options = {
        chart: {
            toolbar: { show: false },
            fontFamily: "inherit",
            zoom: { enabled: false },
        },
        colors: [CHART_COLORS.blue, CHART_COLORS.purple],
        stroke: { curve: "smooth", width: 3 },
        fill: {
            type: "gradient",
            gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.02, stops: [0, 90, 100] },
        },
        dataLabels: { enabled: false },
        grid: { borderColor: "#eef2f7", strokeDashArray: 4 },
        xaxis: {
            categories: labels,
            labels: { style: { colors: "#94a3b8", fontSize: "11px" } },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: { labels: { style: { colors: "#94a3b8", fontSize: "11px" } } },
        legend: { position: "top", horizontalAlign: "right", markers: { radius: 12 } },
        tooltip: { theme: "light" },
    };

    const series = [
        { name: "Units Sold", data: sales },
        { name: "Units Purchased", data: purchases },
    ];

    return (
        <div className="bg-white rounded-2xl shadow-1 p-4 h-full">
            <div className="flex items-center justify-between mb-2">
                <h3 className="font-bold text-slate-800 text-[15px]">Sales vs Purchases Trend</h3>
                <span className="text-[12px] text-slate-400">Monthly units</span>
            </div>
            {hasData ? (
                <Chart options={options} series={series} type="area" height={300} />
            ) : (
                <div className="h-[300px] flex-center text-slate-400 text-[13px]">
                    No sales or purchase history for this window.
                </div>
            )}
        </div>
    );
};

export default SalesTrendChart;
